export const drawer = {
	create: {
		title: "Adicionar produto",
		notifications: {
			success: "Produto criado com sucesso!",
			genericError: "Erro ao criar produto",
		},
		unsavedChanges: {
			title: "Sair da criação",
			message:
				"Tem certeza que deseja sair da criação deste produto? " +
				"Você perderá as informações preenchidas até aqui.",
			cancel: "Cancelar",
			confirm: "Sair da criação",
		},
	},
	edit: {
		title: "Editar produto",
		notifications: {
			success: "Produto atualizado com sucesso!",
			genericError: "Erro ao atualizar produto",
			barUpdateError: "Falha ao atualizar algumas associações de bares.",
			barOperationsFailed: "{{ errorCount }} de {{ total }} operações de bar falharam.",
		},
		unsavedChanges: {
			title: "Sair da edição",
			message:
				"Tem certeza que deseja sair da edição deste produto? " +
				"Você perderá as informações preenchidas até aqui.",
			cancel: "Cancelar",
			confirm: "Sair da edição",
		},
	},
	linkToBars: {
		title: "Vincule seu produto aos bares",
		message:
			"Produto cadastro com sucesso! Agora só falta vincular aos bares para começar a vender",
		searchBars: "Buscar bares",
		selectPlaceholder: "Pesquise bares disponíveis para vincular",
		suggestionText: "Sugestões de bares",
		addAll: "Adicionar todos",
		removeAll: "Remover todos",
		skip: "Pular",
		linkProduct: "Concluir",
		finishWithoutLinking: "Concluir sem vincular",
		stock: "Estoque",
		internalIp: "IP Impressora",
		notifications: {
			success: "Produto vinculado ao(s) bar(es) com sucesso!",
			finishedWithoutLinking: "Produto cadastrado com sucesso!",
			error: "Falha ao vincular o produto a {{ errorCount }} bar(es).",
			genericError: "Erro ao vincular produto ao(s) bar(es).",
			allFailed:
				"Falha ao vincular o produto a todos os {{ total }} bares selecionados: {{ bars }}",
			partialSuccess:
				"Produto vinculado a {{ successCount }} de {{ total }} bares. " +
				"{{ errorCount }} falhou(aram): {{ failedBars }}",
		},
		success: {
			title: "Produto cadastrado com sucesso!",
			message:
				"Seu produto já está ativo em bares e você pode configurá-los nos bares também.",
			understand: "Entendi",
		},
	},
};
